<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { setclientSessionId, disabledScale } from '@/lib/utils';
import api from '@/apis/api';
import md5 from 'js-md5';
import { decryptByAES } from '@/lib/security';
export default {
  async created() {
    // await this.setSafeCode();
  },
  mounted() {
    document.documentElement.addEventListener(
      'touchstart',
      function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      },
      false
    );
    var lastTouchEnd = 0;
    document.documentElement.addEventListener(
      'touchend',
      function(event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
    disabledScale();
  },
  methods: {
    async setSafeCode() {
      let params = {
        clientSessionId: sessionStorage.sessionId || setclientSessionId(),
        t: Date.now(),
        client: 'h5',
      };
      params.encrypt = md5(params.client + params.clientSessionId + params.t);
      const res = await api.getSafeCode(params);
      sessionStorage.setItem(
        'safeCode',
        decryptByAES(res.data, '6f0c5ba452b24fa28989e9524d77407a')
      );
    },
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  overflow: hidden;
  -webkit-text-size-adjust: 100%;
}
img {
  width: 100%;
  height: 100%;
}
.toast-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2020;
}
.toast {
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  width: fit-content;
  min-width: 96px;
  max-width: 70%;
  min-height: 0;
  font-size: 14px;
  padding: 8px 12px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-sizing: content-box;
  color: #fff;
  line-height: 20px;
  white-space: pre-wrap;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  transform: translate(-50%, -50%);
}
.loading {
  position: relative;
  font-size: 0;
  vertical-align: middle;
  padding: 4px;
  color: #fff;
  span {
    position: relative;
    display: inline-block;
    width: 30px;
    max-width: 100%;
    height: 30px;
    max-height: 100%;
    vertical-align: middle;
    animation: loading-rotate 0.8s linear infinite;
    animation-timing-function: steps(12);
  }
  i {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &::before {
      display: block;
      width: 2px;
      height: 25%;
      margin: 0 auto;
      background-color: currentColor;
      border-radius: 40%;
      content: ' ';
    }
  }
  i:nth-of-type(1) {
    transform: rotate(30deg);
    opacity: 1;
  }
  i:nth-of-type(2) {
    transform: rotate(60deg);
    opacity: 0.9375;
  }
  i:nth-of-type(3) {
    transform: rotate(90deg);
    opacity: 0.875;
  }
  i:nth-of-type(4) {
    transform: rotate(120deg);
    opacity: 0.8125;
  }
  i:nth-of-type(5) {
    transform: rotate(150deg);
    opacity: 0.75;
  }
  i:nth-of-type(6) {
    transform: rotate(180deg);
    opacity: 0.6875;
  }
  i:nth-of-type(7) {
    transform: rotate(210deg);
    opacity: 0.625;
  }
  i:nth-of-type(8) {
    transform: rotate(240deg);
    opacity: 0.5625;
  }
  i:nth-of-type(9) {
    transform: rotate(270deg);
    opacity: 0.5;
  }
  i:nth-of-type(10) {
    transform: rotate(300deg);
    opacity: 0.4375;
  }
  i:nth-of-type(11) {
    transform: rotate(330deg);
    opacity: 0.375;
  }
  i:nth-of-type(12) {
    transform: rotate(360deg);
    opacity: 0.3125;
  }
}
@keyframes loading-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
